import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dictionary items" }

import FixfloSelector from './partials/FixfloSelector.vue';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'FixfloAdapter',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FixfloSelector, {
      showSections: true,
      showTypes: true,
      showItems: true
    })
  ]))
}
}

})